import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import Hero from 'wonderbly-components/lib/Hero';
import { localiseUrlII } from 'src/common/utils/format-localised-url';
import { useCountry } from 'src/client/js/view/hooks';

const HomepageHero = props => {
  const country = useCountry();
  const ctas = props.items.map(cta => ({
    ...cta,
    href: cta.href ? localiseUrlII(country, cta.href) : null,
  }));

  return (
    <Hero
      containerClass="container-guttered"
      invert={props.invert}
      title={props.title}
      body={props.body}
      ctas={ctas}
      backgroundColor={props.backgroundColor}
      image={isEmpty(props.backgroundImage) ? null : props.backgroundImage}
    />
  );

};
HomepageHero.propTypes = {
  invert: PropTypes.bool,
  title: PropTypes.string.isRequired,
  body: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundImage: PropTypes.object,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      cta: PropTypes.string,
      ctaColor: PropTypes.string,
      ctaStyle: PropTypes.string,
      href: PropTypes.string,
    })
  ),
};

HomepageHero.defaultProps = {
  invert: false,
};

export default HomepageHero;
